var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3087 3.14418C10.7682 3.14418 2.19674 11.5546 2.19674 21.8963C2.19687 32.2379 10.768 40.6485 21.3079 40.6485C31.8482 40.6485 40.4191 32.238 40.4191 21.8963C40.4196 11.5546 31.8476 3.14418 21.3087 3.14418ZM21.3087 42.8039C9.56015 42.8039 0 33.4235 0 21.8963C0.000370593 10.3692 9.55991 0.98877 21.3079 0.98877C33.0562 0.98877 42.6159 10.3692 42.6159 21.8963C42.6161 33.4234 33.0558 42.8039 21.3087 42.8039Z",
    fill: "#D6DC40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0453 32.1432L13.6025 21.8962L24.0453 11.6494L25.6011 13.1755L16.7134 21.8962L25.6011 30.6171L24.0453 32.1432Z",
    fill: "#D6DC40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.88d61f746f4aaf5e64fb9c59c8d2e25b.svg";
export { ForwardRef as ReactComponent };